/* PartHeaderRenderer.js */

"use strict";

class PartHeaderRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("header"); //TODO Setup the root Element
        this._rootElem.component = this._model;
        this._titleElement = undefined;
        this._iconElement = undefined;
        this._closeButtonElem = undefined;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._titleElement = undefined;
            this._iconElement = undefined;
            this._closeButtonElem = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        //this._rootElem.addEventListener("dblclick", this._onDblClick = this._onDblClick.bind(this)); //not used
        this._model.on("partIconChanged", () => this.render());
        this._model.on("titleChanged", () => this.render());
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
    }

    _unregisterListeners() {
        if (this._closeButtonElem) {
            this._closeButtonElem.removeEventListener("click", this._closeButtonHandler);
        }
        //this._rootElem.removeEventListener("dblclick", this._onDblClick);
        this._model.removeListener("Shutdown", this._onShutdown);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._renderIcon();
        this._renderTitle();
        this._renderCloseButton();
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }

    _closeButtonHandler() {
        this._model._closeButtonClicked();
    }

    /*
  _onDblClick(){
      this._model._doubleClicked();
  }
  */
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */

    /*******************************************/
    _renderIcon() {
        if (!this._iconElement) {
            this._iconElement = document.createElement("lmrb-icon-gl");
            this._iconElement.setAttribute("data-icon", this._model.partIcon);
            this._iconElement.setAttribute("data-lmrb-side", this._model._quadrantName);
            this._rootElem.appendChild(this._iconElement);
        }
    }

    _renderTitle() {
        if (!this._titleElement) {
            this._titleElement = document.createElement("h1");
            this._titleElement.classList.add("title");
            this._rootElem.appendChild(this._titleElement);
        }
        this._titleElement.innerText = this._model.title;
    }

    _renderCloseButton() {
        if (!this._closeButtonElem) {
            this._closeButtonElem = document.createElement("actionable-icon-gl");
            this._closeButtonElem.dataset.icon = "common.close";
            this._closeButtonElem.setAttribute("data-dark-theme", "true");
            this._closeButtonElem.classList.add("quadrant-close-button");
            this._closeButtonElem.addEventListener(
                "click",
                (this._closeButtonHandler = this._closeButtonHandler.bind(this))
            );
            this._rootElem.appendChild(this._closeButtonElem);
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PartHeaderRenderer;
